export const LOAD_REQUESTED = "ASSIGNED_DOCUMENTS/LOAD_REQUESTED";
export const LOAD_SUCCESS = "ASSIGNED_DOCUMENTS/LOAD_SUCCESS";
export const LOAD_FAIL = "ASSIGNED_DOCUMENTS/LOAD_FAIL";

// eslint-disable-next-line no-unused-vars
export default (state = {}, { type, data }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        return state;
    }
    case LOAD_SUCCESS: {
        return state;
    }
    case LOAD_FAIL: {
        return state;
    }
    default: return state;
    }
};

export const requestLoadAssignedDocuments = data => ({ type: LOAD_REQUESTED, data });
export const successLoadAssignedDocuments = data => ({ type: LOAD_SUCCESS, data });
export const failLoadAssignedDocuments = data => ({ type: LOAD_FAIL, data });
